var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-submenu"},[_c('div',{staticClass:"navbar-submenu__title text-uppercase strong"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"navbar-submenu__options-wrapper"},_vm._l((_vm.refinedMenuOptions),function(option){return _c('div',{key:option.id,class:[
        'navbar-submenu__option',
        { 'is-focused': _vm.focusedOption === option.value },
        'align-items-center flex-row d-flex',
      ],on:{"click":function($event){return _vm.$emit('click:option', option)}}},[_c('IconWrapper',{staticClass:"title-icon-background pr-2",attrs:{"icon":option.icon,"size":14}}),_vm._v(" "+_vm._s(option.label)+" ")],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }